export const getDiffrentTime = (time) =>  {
    let diff = new Date().getTime() - new Date(time).getTime();
    let hours = Math.floor(diff / (1000 * 3600))
    let days = Math.floor(diff / (1000 * 3600 * 24))
    if (hours < 1) {
        return `کمتر از یک ساعت پیش`
    } else if (days >= 1) {
        return `${days} روز پیش`
    } else {
        return `${hours} ساعت پیش`;
    }
}